import { booleanAttribute, ChangeDetectionStrategy, Component, computed, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { UpperCasePipe } from '@angular/common';
import { navLinks } from '@core/components/header/nav-links/nav-links.config';
import { TranslateModule } from '@ngx-translate/core';
import { CustomLinkDirective } from '@shared/directives/custom-link/custom-link.directive';
import { StoreState } from '@store/store.state';
import { Store } from '@ngrx/store';
import { userSelectors } from '@store/selectors/user.selectors';
import { MatBadgeModule } from '@angular/material/badge';
import { notificationsSelectors } from '@store/selectors/notifications.selectors';
import { NotificationCounters } from '@core/domain/model/notifications/notification-counter.model';
import { HeaderNotification } from '@core/domain/model/notifications/notification.model';
import { ApplyPipe } from 'ngxtension/call-apply';
import { appActions } from '@store/actions/app.actions';
import { appSelectors } from '@store/selectors/app.selectors';

@Component({
  selector: 'ac-nav-links',
  standalone: true,
  templateUrl: './nav-links.component.html',
  styleUrls: ['./nav-links.component.scss'],
  imports: [TranslateModule, RouterLink, RouterLinkActive, UpperCasePipe, CustomLinkDirective, MatBadgeModule, ApplyPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavLinksComponent {
  @Input({ transform: booleanAttribute }) side = false;
  protected readonly _navLinkSig = computed(() => {
    const authUserType = this._store.selectSignal(userSelectors.authUser)()?.type;
    const country = this._store.selectSignal(userSelectors.country)();
    return navLinks.filter((link) => country == 'PT' || link.userType.some((type) => type === authUserType));
  });
  protected readonly _countersSig = this._store.selectSignal(notificationsSelectors.counters);
  protected readonly _visitedSig = this._store.selectSignal(appSelectors.visitedHeaderNotifications);

  constructor(private _store: Store<StoreState>) {}

  protected _getCount(
    counters: NotificationCounters,
    routeIsActive: boolean,
    visitedHeaders: Partial<Record<HeaderNotification, true>>,
    header?: HeaderNotification
  ) {
    if (!header || routeIsActive || header in visitedHeaders) {
      return null;
    }
    const count: number = counters[header];
    return count === 0 ? null : count;
  }

  protected _visitHeader(active: boolean, header?: HeaderNotification) {
    if (active && header) {
      this._store.dispatch(appActions.visitedHeader({ header }));
    }
  }
}
